import { FETCH_USERS_PAGINATED } from '@/store/actionTypes'

export const FETCH_SPACE_MEMBERS_SEARCH = `${FETCH_USERS_PAGINATED}_SPACE_MEMBERS_SEARCH`
export const FETCH_SPACE_MEMBERS_SEARCH_SUCCESS = `${FETCH_SPACE_MEMBERS_SEARCH}_SUCCESS`

export const UPDATE_SPACE_ROLE = 'spaces/members/roles/UPDATE'
export const UPDATE_SPACE_ROLE_SUCCESS = `${UPDATE_SPACE_ROLE}_SUCCESS`
